import { useState, useEffect } from "react";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import { Link } from "react-router-dom";
import { CountryService } from "../../services/CountryService";
import BibliographyTable from "../Common/BibliographyTable";

const Bibliography = () => {
  const [bibliography, setBibliography] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getBibliography(0).then((data) => setBibliography(data));
  }, []);

  return (
    <div>
      {AddPageHeader("The Consular Bibliography")}
      <div className="reduce-width">
        <Divider align="center">
          <h1>The Consular Bibliography</h1>
        </Divider>
        <div className="privacy-terms">
          The Consular Bibliography references a variety of formats, such as
          books, book chapters, book reviews, case studies, conference papers,
          essays, interviews, journal articles, magazine articles, op-eds,
          opinion pieces, policy analyses, preprints, reports, research papers,
          technical documents, and theses. The Bibliography is updated and
          published monthly. Have a publication to reference or corrections to
          suggest? Please feel free to{" "}
          <Link
            to="/contact"
            style={{
              color: "black",
              fontWeight: "bold",
            }}
          >
            contact
          </Link>{" "}
          the Center.
        </div>
        <br />
        <div
          className="flex h-full gap-3 justify-content-center"
          style={{ height: "100%" }}
        >
          <a
            href="https://doi.org/10.5281/zenodo.15614106"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "bold",
              width: "220px",
              maxWidth: "90%",
              textDecoration: "none",
            }}
          >
            <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
              <div>Access the most recent edition</div>
            </div>
          </a>
        </div>

        <BibliographyTable
          data={bibliography}
          longDescription
          searchEnabled={true}
        />
      </div>
    </div>
  );
};

export default Bibliography;
